import { render } from "./PbSchoolManagement.vue?vue&type=template&id=92c95074&scoped=true"
import script from "./PbSchoolManagement.vue?vue&type=script&lang=js"
export * from "./PbSchoolManagement.vue?vue&type=script&lang=js"

import "./PbSchoolManagement.vue?vue&type=style&index=0&id=92c95074&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92c95074"]])

export default __exports__